var React = require('react');
var ReactNative = require('react-native');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var PlatformConstants = require('./constants/PlatformConstants');
const Icon = require('./wrappers/ReUpIcon');
var NumericalInput = require('./NumericalInput.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  Animated,
  StyleSheet,
} = ReactNative;

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKSpinner,
} = MK;

var PREDICTION_DELAY = 50;

var PhoneLoyaltyInput = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      extras : {}
    }
  },

  getInitialState : function()
  {
    var locManager = this.props.appManager.getLocalizationManager();
    var phoneNumberButtonStr = locManager.localizedStringForKey("TYPE_PHONE_NUMBER_BUTTON");
    return {
      layout : this.props.initialLayout,
      campaigns : [],
      useCreditCampaign : null,
      referCampaign : null,
      checkInCampaign : null,
      transferLoyaltyCampaign : null,
      isShowingSpinner : false,
      buttonIsEnabled : false,
      buttonTitle : phoneNumberButtonStr
    }
  },

  componentDidMount : function()
  {
  },

  didUpdate : function(data)
  {
    if( typeof data.Campaigns !== 'undefined' )
    {
      var useCreditCampaign = null;
      var referCampaign = null;
      var checkInCampaign = null;
      var transferLoyaltyCampaign = null;
      for( var i = 0; i < data.Campaigns.length; i++ )
      {
        var campaign = data.Campaigns[i];
        if( campaign.Type == "UseCredit" ) useCreditCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "Referral" ) referCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
        if( campaign.Type == "TransferLoyalty" ) transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
      }
      // var useCreditCampaign =  {Type: "UseCredit", DollarsPerPoint: 1};
      // var referCampaign =  {Type: "Referral", ReferrerPoints: 10, RefereePoints: 10};
      // var checkInCampaign =  {Type: "Checkin", DollarsPerPoint: 2, FixedPoints: 0, AssignPoints: 0/1};
      // var transferLoyaltyCampaign =  {Type: "TransferLoyalty", Identifier: ["p", "e"]};

      this.setState({
        campaigns:data.Campaigns,
        useCreditCampaign:useCreditCampaign,
        referCampaign:referCampaign,
        checkInCampaign:checkInCampaign,
        transferLoyaltyCampaign:transferLoyaltyCampaign
      });
    }
  },

  resetPredictions: function()
  {
    this._predictions = [];
    this._currentPhoneNumber = "";
    if( this.refs.phoneInput ) this.refs.phoneInput.clearSelected();
    this.setPredictions();
  },

  _currentPhoneNumber:"",
  _predictions:[],
  setPredictions: function(predictions)
  {
    if( typeof predictions === 'undefined' ) predictions = this._predictions;
    var newPredictions = [];
    var foundMatch = false;
    var locManager = this.props.appManager.getLocalizationManager();
    var phoneNumberButtonStr = locManager.localizedStringForKey("TYPE_PHONE_NUMBER_BUTTON");
    var createAccountStr = locManager.localizedStringForKey("CREATE_USER_TITLE");   
    var continueStr = locManager.localizedStringForKey("CONTINUE_BUTTON");   
    for( var i = 0; i < predictions.length; i++ )
    {
      var user = predictions[i];
      if( user.PhoneNumber.indexOf(this._currentPhoneNumber) == 0 )
      {
        foundMatch = true;
        newPredictions.push(user);
      }
    }
    this._predictions = newPredictions;
    console.log("foundMatch")
    if( foundMatch )
    {
      this.refs.phoneInput.setPredictedValue(this.refs.phoneInput.stringPhoneValue(newPredictions[0].PhoneNumber));
      this.setState({buttonTitle: continueStr, buttonIsEnabled:true});
    }
    else if( this._currentPhoneNumber.length >= 11 )
    {
      this.refs.phoneInput.setPredictedValue("");
      this.setState({buttonTitle: createAccountStr, buttonIsEnabled:true});
    }
    else
    {
      this.refs.phoneInput.setPredictedValue("");
      this.setState({buttonTitle: phoneNumberButtonStr, buttonIsEnabled:false});
    }
  },

  updatePredictions: function(phoneNumber, shouldFetchNew)
  {
    this._currentPhoneNumber = phoneNumber;
    if( !shouldFetchNew )
    {
      this.setPredictions();
      this.setState({isShowingSpinner:false});
      return;
    }

    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;

    this.setState({isShowingSpinner:true});
    thisThing.setPredictions();
    setTimeout(()=>
    {
      if( thisThing._currentPhoneNumber != phoneNumber ) return; // early return because its changed

      NetworkManager.lookUpUserByPhone(appManager, phoneNumber, (result)=>
      {
        if( thisThing._currentPhoneNumber != phoneNumber ) return; // early return because its changed
        thisThing.setState({isShowingSpinner:false});
        thisThing.setPredictions(result);
      }, ()=>
      {
        if( thisThing._currentPhoneNumber != phoneNumber ) return; // early return because its changed
        thisThing.setState({isShowingSpinner:false});
        thisThing.setPredictions();
      }, ()=>
      {
        if( thisThing._currentPhoneNumber != phoneNumber ) return; // early return because its changed
        thisThing.setState({isShowingSpinner:false});
        thisThing.setPredictions();
      })
    }, PREDICTION_DELAY)


  },

  submitPressed: function()
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();

    if( this._predictions.length > 0 )
    {
      var userID = this._predictions[0].UserID;
      var hash = this._predictions[0].Hash;
      var extras = {};
      extras.userID = userID;
      extras.UserID = userID;
      extras.U = userID;
      extras.hash = hash;
      extras.H = hash;
      extras.onlyPoints = true;
      extras.shouldShowResendVerify = true;
      extras.phoneNumber = this._predictions[0].PhoneNumber;
      appActions.requestFeatureName("GiftCardOptions", extras);
    }
    else
    {
      var phone = this._currentPhoneNumber;
      var createAccountAlertStr = locManager.localizedStringForKeyAndParams("CREATE_ACCOUNT_ALERT_BODY", [this.refs.phoneInput.stringPhoneValue()]);
      var processingSpinnerStr = locManager.localizedStringForKey("PROCESSING_SPINNER");

      appActions.showLocalizedAlert("CREATE_ACCOUNT_ALERT_TITLE", createAccountAlertStr, ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
        {
        appActions.setSpinnerShown(false);
        appActions.hideAlert();
      },function()
      {
        appActions.hideAlert();
        appActions.setSpinnerShown(true, thisThing.processingSpinnerStr);
        var failure = function(data)
        {
          appActions.setSpinnerShown(false);
          var createAccountFailureTitle = locManager.localizedStringForKey("CREATE_ACCOUNT_FAILURE_ALERT_TITLE", "Failure");
          var createAccountFailureBody = locManager.localizedStringForKey("CREATE_ACCOUNT_FAILURE_ALERT_BODY", "Could not create account.");
          var yesButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");

          appActions.showAlert(createAccountFailureTitle, createAccountFailureBody, [yesButton], [function()
            {
            appActions.hideAlert();
          }]);
        };
        NetworkManager.createUserByPhone(appManager, phone,null, function(data)
        {
          if( typeof data.UserName !== 'undefined' )
          {
            NetworkManager.lookUpUserByPhone(appManager, phone, function(data)
            {
              if( data.length == 1 )
              {
                appActions.setSpinnerShown(false);
                var extras = {};
                extras.userID = data[0].UserID;
                extras.UserID = data[0].UserID;
                extras.U = data[0].UserID;
                extras.hash = data[0].Hash;
                extras.H = data[0].Hash;
                extras.onlyPoints = true;
                extras.shouldShowResendVerify = true;
                extras.phoneNumber = phone;
                extras.Verified = data[0].Verified;
                appActions.requestFeatureName("GiftCardOptions", extras);

                thisThing.resetPredictions();
              }
              else
              {
                failure();
              }
            }, failure, failure)
          }
          else
          {
            failure();
          }
        },failure, failure)
      }], function(){}, false, false, 20, 18, 20)
    }
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var thisThing = this;
    var generalColor = appManager.getColorForKey("GeneralColor");
    var dollarsPerPoint = 0;
    var isAssignPoints = false;
    if( this.state.checkInCampaign != null && this.state.checkInCampaign.DollarsPerPoint != 0 )
    {
      dollarsPerPoint = this.state.checkInCampaign.DollarsPerPoint;
    }
    else if( this.state.checkInCampaign != null && (typeof this.state.checkInCampaign.AssignPoints !== 'undefined') && this.state.checkInCampaign.AssignPoints != 0 )
    {
      isAssignPoints = true;
    }
    var inputHeight = 400;
    var inputWidth = this.state.layout.width > 620 ? 600 : this.state.layout.width-20;
    var buttonWidth = this.state.layout.width-20;
    var buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var cancelStr = locManager.localizedStringForKey("CANCEL_BUTTON");

    return (
      <View style={[styles.container, {paddingTop:Globals.STATUS_BAR_HEIGHT, backgroundColor:generalColor}]}>
        <ReUpScrollView responder={this}>
          <View style={{flexDirection:'column', alignItems:'stretch'}}>

            <View style={{flex:1, flexDirection:'row'}}>
              <View style={{flex:1}} />
                <NumericalInput ref="phoneInput"
                  style={{height:inputHeight, width:inputWidth, marginTop:20}}
                  isPhoneNumber={true}
                  appManager={this.props.appManager}
                  initialValue={"1"}
                  valueChanged={(newValue,newStringValue)=>
                  {
                    var phoneNumber = thisThing.refs.phoneInput.strippedPhoneNumber(newValue);
                    thisThing.updatePredictions(phoneNumber, phoneNumber.length >= 7);
                  }}
                />
              <View style={{flex:1}} />
            </View>
            <ReUpButton style={[styles.button,{margin:10, width:buttonWidth, opacity:thisThing.state.buttonIsEnabled ? 1 : .6}]}
              appManager={appManager}
              onPress={() =>
              {
                if( thisThing.state.buttonIsEnabled ) thisThing.submitPressed();
              }}>
              <View style={{flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                <View style={{flex:-1, justifyContent:'flex-start', flexDirection:'row'}}>
                {
                  this.state.isShowingSpinner ?
                  <MKSpinner style={{
                    alignSelf : 'center',
                    backgroundColor : 'transparent',
                  }} strokeColor={[buttonTitleColor]} />
                  :
                  <ReUpText isTitle={true} pointerEvents="none" appManager={appManager}
                        style={{
                                textAlign:'center',
                                lineHeight:24,
                                alignSelf:'center',
                                color: buttonTitleColor,
                                fontFamily: appManager.getFontForKey("Bold"),
                                backgroundColor:'transparent',
                                fontWeight: 'bold',}}>
                    {this.state.buttonTitle}
                  </ReUpText>
                }
                </View>
              </View>
            </ReUpButton>

            <ReUpButton isSecondary={true} style={[styles.button,{margin:10, width:buttonWidth}]}
              appManager={appManager}
              text={cancelStr}
              onPress={() =>
              {
                thisThing.props.appActions.requestPop();
                if( typeof thisThing.props.extras.scanner !== 'undefined' && thisThing.props.extras.disableAutoScannerLaunch != true )
                {
                  setTimeout(function()
                  {
                    thisThing.props.extras.scanner.scan();
                  },300)
                }
              }}
              />

          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    backgroundColor:'white'
  },
  actionBarSpacer: {
    height:0,//Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
});


PhoneLoyaltyInput.dataDependencies = ["Campaigns"]

module.exports = PhoneLoyaltyInput;



// WEBPACK FOOTER //
// ./src/PhoneLoyaltyInput.js